import React, {useEffect} from 'react'
import WebFont from 'webfontloader';
// eslint-disable-next-line
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
import {Container, Row, Card, Button, Table, Form, Badge} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faEye, faIndustry, faPlusCircle, faSearch} from '@fortawesome/free-solid-svg-icons'
import NavBar from "../navbar/Navbar";
import {get, post} from '../../controllers/Endpoints'
import "../../styles/styles.css";
import { getUserToken } from '../../controllers/UserController';

export default function Providers(){

    const [tableColumns, setTableColumns] = React.useState([]);
    const [tableRows, setTableRows] = React.useState([]);

    const PAGE_TITLE = "Proveedores";
    const PAGE_ICON = faIndustry;
    
    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Roboto:100,300,400']
            }
        });

        document.title = `GrinBalb - ${PAGE_TITLE}`;
        setupTable();
        getProviders();
    }, []);

    const handleSearchChain = (event) => {
        const chain = event.target.value;

        if(chain === ""){
            getProviders();
        }else{
            searchProviders(chain)
        }
    };

    const searchProviders = async function(c){
        const chain = {
            chain: c
        }

        const req = await post('/business/type/PROVIDER/search', getUserToken(), chain);
        const res = await req.json();

        if(req.status === 200){
            processProviders(res)
        }else{
            alert(res.message);
        }
    }

    const setupTable = function(){
        const cols = ['Código', 'Nombre', 'CUIT', 'Razón social', 'Tipo', ''];
        setTableColumns(cols);
    };

    const getProviders = async function(){
        const req = await get('/business/type/PROVIDER', getUserToken());
        const res = await req.json();

        if(req.status === 200){
            console.log(res)
            processProviders(res)
        }else{
            alert(res.message);
        }
    }

    const processProviders = function(providers){
        let result = [];
        for(let p of providers){
            p.action = <Link to={`/proveedores/detalles/?id=${p.id}`}><Button className='buttonBlue' variant="primary"><FontAwesomeIcon icon={faEye}></FontAwesomeIcon></Button></Link>
            p.type = (
                p.BusinessProviderTypes.map((c, i) => (
                    <span className='me-1' key={i}><Badge bg='primary' className='content-table status'>{c.ProviderType.name}</Badge></span>
                ))
            )
            result.push(p);
        }
        setTableRows(result);
    }

    return(
        <div className='p-0' style={{fontFamily: 'Roboto'}}>
            <style>{'body {background-color: #EBEBEB !important;}'}</style>
            <NavBar/>

            <div style={{height: 300, background: '#FAFAFA'}}>
                <Container>
                    <Row style={{paddingTop: 10}}>
                        <table className='w-75' style={{marginLeft: 'auto', marginRight: 'auto'}}>
                            <tr>
                                <td style={{fontSize: 45, fontWeight: 300}}>
                                <span style={{color: '#A0A0A0'}}>{PAGE_TITLE}</span>
                                </td>
                                <td style={{fontSize: 140, width: 150}}>
                                    <FontAwesomeIcon icon={PAGE_ICON} style={{fontSize: 140, color: "A0A0A0"}} />
                                </td>
                            </tr>
                        </table>
                    </Row>
                </Container>
            </div>

            <Container>
                <Row style={{marginTop: -70}}>
                    <Card className='cards content mb-5'>
                        <table className='header content'>
                            <tr>
                                <td className='header rows left'>
                                    <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon><Form.Control className='cover content rows element ms-2' style={{width: 250}} type="text" id="businessIdentifier" placeholder="" onChange = {(event) => handleSearchChain(event)} />
                                </td>
                                <td className='header rows right'>
                                    <Link to='/proveedores/nuevo'>
                                        <Button variant="success"><FontAwesomeIcon icon={faPlusCircle} style={{marginRight: 8}} />Nuevo proveedor</Button>
                                    </Link>
                                </td>
                            </tr>
                        </table>
                        




                        <Table striped hover className='mt-3'>
                            <thead>
                                <tr>
                                    {tableColumns.map((c, i) => (
                                        <th key={i} className='opTable head'>{c}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {tableRows.map((r, i) => (
                                    <tr key={i} >
                                        <td className='opTable rows align-middle'>{r.identifier}</td>
                                        <td className='opTable rows align-middle'>{r.name}</td>
                                        <td className='opTable rows align-middle'>{r.legalId}</td>
                                        <td className='opTable rows align-middle'>{r.legalName}</td>
                                        <td className='opTable rows align-middle'>{r.type}</td>
                                        <td className='opTable rows align-middle'>{r.action}</td>
                                    </tr>
                                ))}
                                
                            </tbody>
                        </Table>
                    </Card>
                </Row>
            </Container>
            
        </div>
    )
}